const s = {
  name: "CardPayout",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,4.6l-2,2V0h-2v6.6l-2-2L7.6,6l4.4,4.4L16.4,6L15,4.6z"/>
		<path class="st0" d="M10,18v2H4v-2H10z"/>
		<path class="st0" d="M2,11c0-0.5,0.5-1,1-1h3.5V8H3c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h18c1.7,0,3-1.3,3-3V11c0-1.7-1.3-3-3-3
			h-3.5v2H21c0.5,0,1,0.5,1,1v1H2V11z M2,21v-7h20v7c0,0.5-0.5,1-1,1H3C2.5,22,2,21.5,2,21z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CardPayout
};
